export default __webpack_public_path__ + "static/media/home-decor-img-08.34719db4.jpg";